import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { faComments } from '@fortawesome/free-solid-svg-icons';
import { MembershipService } from 'app/core/services/membership.service';

declare var Genesys: any;

@Component({
  standalone: false,
  selector: 'app-chat-genesys',
  templateUrl: './chat-genesys.component.html',
  styleUrls: ['./chat-genesys.component.scss']
})

export class ChatGenesysComponent implements OnInit {

  private loadAPI: Promise<any>;
  public faComments = faComments;
  public showTooltip = false;

  constructor(public membership: MembershipService, private router: Router, private ngZone: NgZone) {
    this.loadAPI = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
  }

  ngOnInit(): void {
    this.checkGenesysLoaded();
  }

  private checkGenesysLoaded(): void {
    Genesys('subscribe', 'Messenger.ready', () => {
      this.ngZone.run(() => {
        setTimeout(() => {
          this.showTooltip = true;
        }, 1000);
      });
    });
  }

  public loadScript() {
    const library = "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js";

    let isFound = false;
    const scripts = document.getElementsByTagName("script")
    for (let i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src') === library) {
        isFound = true;
      }
    }

    if (!isFound) {
      const F = new Function(`
        (function (g, e, n, es, ys) {
          g['_genesysJs'] = e;
          g[e] = g[e] || function () {
            (g[e].q = g[e].q || []).push(arguments)
          };
          g[e].t = 1 * new Date();
          g[e].c = es;
          ys = document.createElement('script'); 
          ys.async = 1; 
          ys.src = n; 
          ys.charset = 'utf-8'; 
          document.head.appendChild(ys);
        })(window, 'Genesys', 'https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js', {
          environment: 'prod',
          deploymentId: '13190b17-3e68-4503-a6f2-4fc06b17d7a2'
        });
      `);
      F();
    }
  }

  public startChat() {
    if (typeof Genesys !== 'undefined') {
      Genesys('command', 'Messenger.open');
    }
  }
}
